import { ErrorCode, PaymentType } from '@ace-clublabs/payment-types';

export interface ICardFormProps {
  manifestId: string;
  paymentType: PaymentType;
  amount: number;
  returnUrl: string;
  isScheduled: boolean | undefined;
  autoPay?: boolean;
  tokenOnly?: boolean;
  tags?: object;
  appId?: string;
  softErrorCode?: ErrorCode;
  scheduledDate?: string;
  paymentFormSubtitle?: string;
  setParentProcessing?: any;
  isUnitTest?: boolean;
}

export interface ICardFormFieldChange {
  empty: boolean;
  field: string;
  length: number;
  potentiallyValid: boolean;
  selector: string;
  touched: boolean;
  valid: boolean;
}
export interface ICardFormFieldBlur {
  field: string;
  selector: string;
}

export interface ICardFormState {
  [key: string]: ICardFormFieldChange;
}

export enum FieldErrorType {
  None,
  IsNotValid,
  IsRequired,
  IsMinLength,
  IsMaxLength,
}

export interface IFieldError {
  type: FieldErrorType;
  message?: string;
}
